import { render, staticRenderFns } from "./StandardAccountPlan.vue?vue&type=template&id=49a0a35f&scoped=true"
import script from "./StandardAccountPlan.vue?vue&type=script&lang=js"
export * from "./StandardAccountPlan.vue?vue&type=script&lang=js"
import style0 from "./StandardAccountPlan.vue?vue&type=style&index=0&id=49a0a35f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a0a35f",
  null
  
)

export default component.exports